export default __webpack_public_path__ + "static/media/siritLogo.6a4fcb62.png";